/**
 * 系统预设头像（男 / 女 / 中性）前端类型。
 *
 * 后端契约见 GET /api/public/avatars：URL 都是读取时现签的预签名地址（默认 4 小时过期），
 * 因此前端只把 code 回传给后端做选择，绝不缓存或提交 URL。
 */

/** 头像分类，取值与后端 AvatarCategory 的入库值逐字一致。 */
export type AvatarCategoryKey = 'male' | 'female' | 'neutral'

/** 分类筛选控件的展示文案。 */
export const AvatarCategoryLabels: Record<AvatarCategoryKey, string> = {
  male: '男生',
  female: '女生',
  neutral: '中性',
}

/** 全站默认头像位编码，与后端 SystemAvatarCatalog.DEFAULT_CODE 逐字一致。 */
export const DEFAULT_AVATAR_CODE = 'neutral_default'

/** 默认头像在库里的形态（object key，不是预签名 URL），与后端 SystemAvatarCatalog.mainKey 同源。 */
export const DEFAULT_AVATAR_KEY = `avatars/${DEFAULT_AVATAR_CODE}.png`

export interface SystemAvatar {
  id: string
  /** 稳定业务编码（如 male_01、neutral_default），选择头像时提交该值 */
  code: string
  category: AvatarCategoryKey
  /** 展示名，如「男·软件工程师」 */
  name: string
  /** 主图（256）现签地址；MinIO 关闭时为 null */
  url: string
  /** @2x 图（512）现签地址，选中预览用 */
  url2x: string
  /** 缩略图（64）现签地址，网格渲染用 */
  thumbnailUrl: string
  fileName: string
  /** 主图字节数 */
  fileSize: number
  /** 主图 object key，仅用于展示与排查，不参与提交 */
  storagePath: string
  /** 是否全站默认头像位 */
  isDefault: boolean
}
